/* eslint-disable fp/no-mutation,react/jsx-filename-extension */
import React from 'react';

import { ComparisonContainer } from './comparison';
import { ComparisonSelfServe } from './comparison-self-serve';
import { ComparisonTableContainer } from './comparison-table';
import { ComparisonTableHero, ComparisonTableHeroContainer } from './comparison-table-hero';
import ComparisonTableVersus from './comparison-table-versus';
import { ProviderComparison } from './provider-comparison-widget';
import { hasEnoughProviders as hasEnoughLargestProviders } from './provider-filters/largest-provider';
import { fetchQuotes } from './resources/clients';
import transformQuotesResponse from './resources/clients/quotes/transformQuotesResponse';
import transformQuotesResponseV2 from './resources/clients/quotes/transformQuotesResponseV2';
import {
  isWiseQuote,
  isPartnerQuote,
  isBankQuote,
  isMoneyTransferProviderQuote,
} from './resources/quoteFilters';
import {
  supportsCalculatingSavingAgainstMostExpensiveBank,
  calculateSavingAgainstMostExpensiveBankInTargetCurrency,
  calculateSavingAgainstMostExpensiveBankInSourceCurrency,
} from './resources/savingsCalculator';
import { TransferFeeComparisonContainer } from './transfer-fee-comparison';
import { TravelMoney } from './travel-money';

ComparisonContainer.componentType = 'Comparison';
ComparisonTableContainer.componentType = 'Comparison Table';

export {
  ComparisonContainer as Comparison, // FIXME: Naming consistency, + expose presentational components
  ComparisonTableContainer as ComparisonTable,
  ComparisonTableHero,
  ComparisonTableHeroContainer,
  ComparisonTableVersus,
  ComparisonSelfServe,
  ProviderComparison,
  TravelMoney,
  TransferFeeComparisonContainer,
  fetchQuotes,
  transformQuotesResponse,
  supportsCalculatingSavingAgainstMostExpensiveBank,
  calculateSavingAgainstMostExpensiveBankInTargetCurrency,
  calculateSavingAgainstMostExpensiveBankInSourceCurrency,
  isWiseQuote,
  isPartnerQuote,
  isBankQuote,
  isMoneyTransferProviderQuote,
  hasEnoughLargestProviders,
  transformQuotesResponseV2,
};
